// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://kxhdpglcgypuvelefrnw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt4aGRwZ2xjZ3lwdXZlbGVmcm53Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk4ODAxNzYsImV4cCI6MjA4NTQ1NjE3Nn0.oKbh83QrziHiApI0HqP8FmweyYwfkt4e0geHWHHFCIk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
